export default "__VITE_ASSET__DWNWBXaB__"